export const FULFILLED = 'fulfilled'
export const REJECTED = 'rejected'
